export default __webpack_public_path__ + "static/never-forget-c1557d8ed7160447b4a41bbdd4813082.webp";